import { useContext } from 'react'
import { Box } from '@mui/material'
import { Outlet } from 'react-router-dom'

import LoadingContext from 'Contexts/LoadingContext'
import Navigation from 'Components/Navigation'
import Spinner from 'Components/Spinner'

export default function Layout() {
	const { loading } = useContext(LoadingContext)
	return (
		<>
			<Navigation />

			<Box sx={{ maxWidth: '1400px', margin: '0 auto' }}>
				<Outlet />
				{loading && <Spinner />}
			</Box>
		</>
	)
}

